import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=6aa818a0&"
import script from "./Button.vue?vue&type=script&lang=js&"
export * from "./Button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/user/projects/zp-front-up/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aa818a0')) {
      api.createRecord('6aa818a0', component.options)
    } else {
      api.reload('6aa818a0', component.options)
    }
    module.hot.accept("./Button.vue?vue&type=template&id=6aa818a0&", function () {
      api.rerender('6aa818a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/buttons/Button.vue"
export default component.exports